import React, { useEffect } from 'react'
import { MdMenu } from 'react-icons/md';
import HeaderRight from './HeaderRight';
import AvatarCard from './AvatarCard';
import { useDispatch, useSelector } from 'react-redux';
import MobileHeaderRight from './MobileHeaderRight';
import { isShowHeaderRight } from '../../redux/slices/showHeaderRightSlice';
import { fetchAuth } from '../../redux/slices/authSlice';

const Header = () => {
    const dispatch = useDispatch()
    const isRightMenu = useSelector(state => state.showHeaderRight.showHeaderRight)
    const handleShowRightMenu = async () => await dispatch(isShowHeaderRight())
    const user = useSelector(state => state.auth.auth)

    useEffect(() => {
        dispatch(fetchAuth())
    }, [dispatch])

    return (
        <div className='header'>
            <AvatarCard user={user?.user} />
            <HeaderRight />
            <div
                onClick={handleShowRightMenu}
                className='header-right-btn border h40px w40px justify-content-center align-items-center cp rounded'
            >
                <MdMenu size={25} />
            </div>
            <div className={isRightMenu ? 'd-block' : 'd-none'}>
                <MobileHeaderRight handleShowRightMenu={handleShowRightMenu} />
            </div>
        </div>
    )
}

export default Header
